module.exports = __webpack_public_path__ + "static/media/Instagram-Logo.10ef1dc7.webp";